import { MessageBarType } from '@fluentui/react';
import React, { useEffect, useState } from 'react';
import { DoorInstallationModel, IDoorInstallationModel } from '../../../../entities-generated/models/project/door-installation-model';
import { ToastService } from '../../../../framework/services/toast';
import { firstOrDefault } from '../../../../framework/utils/collection';
import { ProductDetailDialog } from '../pdct-detail-dialog';
import { IStormDoorHandleModel, StormDoorHandleModel } from '../../../../entities-generated/models/storm-door/storm-door-handle-model';
import { ShopStormHandleApiClient } from '../../../../services/shop-storm-door-handle';
import { ProductTexture } from '../../../../entities-generated/common/product-texture';

interface IStormHandleDetailDialogProps {
  info: { door: IDoorInstallationModel, site: string } | undefined;
  onChangeRequested: (door: IDoorInstallationModel, site: string) => void;
  onCloseDialog: () => void;
}

export const StormHandleDetailDialog: React.FunctionComponent<IStormHandleDetailDialogProps> = (props) => {
  const { info, onCloseDialog } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [handle, setHandle] = useState<IStormDoorHandleModel>(new StormDoorHandleModel());

  useEffect(() => {
    if(info === undefined) { return; }

    setIsLoading(true);
    ShopStormHandleApiClient.getSelectedStormDoorHandle(info.door.id)
    .then(resp => {
      const selectedVariant = firstOrDefault(resp.textureVariants, v => v.id === info.door.selectedHandle!.textureVariant.id) ?? resp.textureVariants[0];
      resp.textureVariants = [selectedVariant];
      setHandle(resp);
      setIsLoading(false);
    })
    .catch(() => {
      ToastService.show(MessageBarType.error, 'Sorry, we hit a snag - please try again');
      onCloseDialog();
    });
  }, [info, onCloseDialog]);

  const dim = info?.door ?? new DoorInstallationModel();
  return (
    <ProductDetailDialog
      id={handle.id}
      title={`Storm Door Handle - ${info?.site ?? ''}`}
      brand={handle.brand}
      description={handle.description}
      price={0}
      keyFeatures={handle.sellingPoints}
      variant={handle.textureVariants[0] ?? new ProductTexture()}
      variantDescriptor={'finish'}
      onChangeSelection={() => props.onChangeRequested(dim, info?.site ?? '')}
      imageUrls={[handle.imageUrl, ...handle.auxImageUrls]}
      showDialog={!!info}
      isLoading={isLoading}
      onCloseDialog={props.onCloseDialog}
    />
  );
};
